module.exports = __webpack_public_path__ + "img/VF.7e30868b.png";